/**
There is several sensetive env variables that exposed via runtime(netlify).

HUBSPOT_API_KEY:
 - https://app.netlify.com/projects/finn-ua/configuration/env#HUBSPOT_API_KEY
 - https://app.netlify.com/projects/finn-staging-integration/configuration/env#HUBSPOT_API_KEY

PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-ua/configuration/env#PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-staging-integration/configuration/env#PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-customerportal/configuration/env#PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-staging-customerportal/configuration/env#PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-b2b/configuration/env#PRODUCT_API_KEY
 - https://app.netlify.com/projects/finn-b2b-staging/configuration/env#PRODUCT_API_KEY

DECAGON_SECRET
 - https://app.netlify.com/projects/finn-ua/configuration/env#DECAGON_SECRET
 - https://app.netlify.com/projects/finn-staging-integration/configuration/env#DECAGON_SECRET

GOOGLE_MAPS_SERVER_API_KEY
 - https://app.netlify.com/projects/finn-ua/configuration/env#GOOGLE_MAPS_SERVER_API_KEY
 - https://app.netlify.com/projects/finn-staging-integration/configuration/env#GOOGLE_MAPS_SERVER_API_KEY

COSMIC_BUCKET_READ_KEY
 - https://app.netlify.com/projects/finn-ua/configuration/env#COSMIC_BUCKET_READ_KEY
 - https://app.netlify.com/projects/finn-staging-integration/configuration/env#COSMIC_BUCKET_READ_KEY

AUTH0_SECRET
 - https://app.netlify.com/projects/finn-b2b/configuration/env#AUTH0_SECRET
 - https://app.netlify.com/projects/finn-b2b-staging/configuration/env#AUTH0_SECRET

AUTH0_CLIENT_SECRET
 - https://app.netlify.com/projects/finn-b2b/configuration/env#AUTH0_CLIENT_SECRET
 - https://app.netlify.com/projects/finn-b2b-staging/configuration/env#AUTH0_CLIENT_SECRET

FLEET_CONFIGURATION_API_KEY
 - https://app.netlify.com/projects/finn-b2b/configuration/env#FLEET_CONFIGURATION_API_KEY
 - https://app.netlify.com/projects/finn-b2b-staging/configuration/env#FLEET_CONFIGURATION_API_KEY
*/

const productionConfig = {
  FINN_MAIN_DOMAIN: 'https://www.finn.com',
  FINN_WEB_URL: 'https://www.finn.com',
  AUTH_API_URL: 'https://auth-new.netlify.app',
  PRODUCT_API_URL: 'https://product-api.finn.com',
  CHECKOUT_API_URL: 'https://api-checkout.finn.auto',
  VOUCHER_API_URL: 'https://api-voucher.finn.auto',
  REVIEWS_API_URL: 'https://api-reviews.finn.auto',
  HUBSPOT_API_URL: 'https://api.hubapi.com/crm/v3/objects',
  GOOGLE_ANALYTICS_4_WEB: 'G-K7KRXNGPYV',
  UA_FE_ACTOR: 'ua_frontend',
  UA_FE_SSR_ACTOR: 'ua_frontend_ssr',
  FINN_APP_SCHEME: 'finnautoapp://',
  APP_PREVIEW_PREFIX: 'finnautoapppreview://',
  DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE: 20,
  DATADOG_APPLICATION_ID:
    process.env.DATADOG_APPLICATION_ID ||
    'a3422b68-51d0-4ec3-a45c-2bb483409d25',
  DATADOG_VERSION: process.env.DATADOG_VERSION || '1.0.0',
  GMC_TAG: 'Xa9ZgPjLkRZp7GaPTMDzzki733VjXQ0eg8A2a51wJOQ',
  ZENDESK_APP_ID: 'app_65eed05154a0031b563396b7',
  USERCENTRICS_ID: '7iYitN9k',
  APPS_FLYER_SMART_BANNER_ID: '75007f8c-c424-4fa5-bedb-97b945f34805',
  CLOUDINARY_REMOTE_IMAGE_FETCH_URL:
    'https://res.cloudinary.com/finn-auto/image/fetch/',
  TRACKING_TEST_EMAIL: 'afzal.hossain+track+test@finn.auto',
  DEPLOY_URL: process.env.NEXT_PUBLIC_DEPLOY_URL ?? 'https://www.finn.com',
  APP_STAGE: 'production',
  COSMIC_USE_S3: process.env.NEXT_PUBLIC_COSMIC_USE_S3 || '',
  FLEET_CONFIGURATION_API_URL: 'https://fleet-configuration-api-ger.finn.auto',
  B2B_API_ENDPOINTS: {
    ADDONS: 'https://addons-api.b2b.finn.com',
    CHECKOUT_V0: 'https://orders-api.b2b.finn.com/v0',
    CHECKOUT_V1: 'https://orders-api.b2b.finn.com/v1',
    SUBSCRIPTIONS: 'https://b2b-subscriptions-api.finn.auto/v1',
    COMPANIES: 'https://companies.de.b2b.finn.com/api/v0',
    ORDERS: 'https://orders-api.b2b.finn.com',
    ORDERS_V2: 'https://orders-api.b2b.finn.com/v2',
    PRODUCT: 'https://product-api.finn.com/b2b',
    DELIVERY: 'https://api-delivery.finn.auto/v1',
    LEADS: 'https://api-lead.finn.auto/v0',
    INVOICES: 'https://invoice-b2b.finn.auto/v1',
    FINANCE_BILLING: 'https://api-billing.finance.finn.auto',
    FINANCE_INVOICING: 'https://api-invoicing.finance.finn.auto',
    OPS_CARS: 'https://api-ops-cars.finn.auto',
    OPS_SUBSCRIPTIONS: 'https://api-ops-subscriptions.finn.auto',
    OPS_APPRAISALS: 'https://api-ops-appraisals.finn.auto',
    AUTH0_BASE_URL: process.env.AUTH0_BASE_URL || '',
  },
  // it is safe to have DATADOG_CLIENT_TOKEN hardcoded on client side,
  // according to datadog docs, as this token more like id and not a secret.
  // it needs to be passed to js script tag. We also do not hardcode it here, as it differ between apps
  DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN || '',
  // it is safe to have ANALYTICS_WRITE_KEY hardcoded on client side,
  // as this is a public key used to send events to segment.
  // it needs to be passed to js script tag. We also do not hardcode it here, as it differ between apps
  // it is also used in SetupAnalytics component to load
  ANALYTICS_WRITE_KEY: process.env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY || '',
  // these are publishable/public keys, so it's not a security issue to have it in source code.
  // Having them in env variable is problematic as we're reaching the 4kb env variable limit
  STRIPE: {
    DE_PUBLISHABLE_KEY: 'pk_live_65j0ShiPOlhoPtEf8Bf7TztH00psbnKRMs',
    ABS_DE_PUBLISHABLE_KEY:
      'pk_live_51JrkEqHfRoBp5g8KJ8oXnGXkYZc4qIU6iHjOXwMyfaTMXVW2tueDk9htEiBoumPVXWbfID1MFdA51jDVtOkp85RE00rEK5Eo87',
    E2E_DE_PUBLISHABLE_KEY: 'pk_test_SbCnSrPH0r7zEyklLZTv5AAD00pI5fqzsQ',
    E2E_ABS_DE_PUBLISHABLE_KEY:
      'pk_test_51JrkEqHfRoBp5g8KMn3UrQV8Y2PZMRisN3eEvbF9Uroyz35pwiwyk4NB3QIaAMiBL2aXZv02qJ9riRq3RqlmPqSN00JCjBhRER',
  },
};

const isDeployPreview = () =>
  process.env.CONTEXT === 'deploy-preview' || process.env.CONTEXT === 'preview';

const stagingConfig = {
  FINN_MAIN_DOMAIN: 'https://staging.finn.com',
  AUTH_API_URL: 'https://dev--auth-new.netlify.app',
  // for historycal reasons we show production products api on deploy preview,
  // but staging in staging
  PRODUCT_API_URL: isDeployPreview()
    ? productionConfig.PRODUCT_API_URL
    : (process.env.PRODUCT_API_URL ?? 'https://staging-product-api.finn.com'),
  VOUCHER_API_URL: isDeployPreview()
    ? productionConfig.VOUCHER_API_URL
    : 'https://dev-api-voucher.finn.auto',
  REVIEWS_API_URL: 'https://dev-api-reviews.finn.auto',
  UA_FE_ACTOR: 'ua_frontend_staging',
  UA_FE_SSR_ACTOR: 'ua_frontend_ssr_staging',
  DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE: 0,
  APP_STAGE: 'preview',
  FLEET_CONFIGURATION_API_URL:
    'https://stg-fleet-configuration-api-ger.finn.auto',
  STRIPE: {
    ...productionConfig.STRIPE,
    DE_PUBLISHABLE_KEY: productionConfig.STRIPE.E2E_DE_PUBLISHABLE_KEY,
    ABS_DE_PUBLISHABLE_KEY: productionConfig.STRIPE.E2E_ABS_DE_PUBLISHABLE_KEY,
  },
  B2B_API_ENDPOINTS: {
    ...productionConfig.B2B_API_ENDPOINTS,
    ADDONS: 'https://addons-api.b2b-staging.finn.com',
    CHECKOUT_V0: 'https://orders-api.b2b-staging.finn.com/v0',
    CHECKOUT_V1: 'https://orders-api.b2b-staging.finn.com/v1',
    SUBSCRIPTIONS: 'https://stg-b2b-subscriptions-api.finn.auto/v1',
    ORDERS: 'https://orders-api.b2b-staging.finn.com',
    ORDERS_V2: 'https://orders-api.b2b-staging.finn.com/v2',
  },
};

let targetEnv: 'production' | 'staging' = 'production';

if (process.env.APP_NAME === 'B2B') {
  targetEnv = process.env.IS_STAGING === 'yes' ? 'staging' : 'production';
} else {
  targetEnv =
    ['production', 'development'].includes(process.env.APP_STAGE || '') &&
    process.env.NODE_ENV !== 'test'
      ? 'production'
      : 'staging';
}

const config =
  targetEnv === 'production'
    ? productionConfig
    : Object.assign({}, productionConfig, stagingConfig);

export default config;
